<div class="flex flex-col gap-4">
  <p class="text-body-2 text-neutral-60 m-0">
    {{ (store.isAdmin() ? 'aiHub.preferences.introAdmin' : 'aiHub.preferences.introUser') | translate }}
  </p>
  @if (consentPanelShown()) {
    <div
      data-testid="preferences-act-on-behalf-notice"
      class="flex items-start gap-3 p-4 bg-warning-0 border border-solid border-warning-40 rounded-lg"
    >
      <span class="fa-icons icon-regular icon-16 icon-shield-exclamation text-warning-140 shrink-0 mt-1" aria-hidden="true"></span>
      <div class="flex flex-col gap-2 min-w-0">
        <p class="subtitle-1 text-neutral-90 m-0">{{ 'aiHub.preferences.consent.title' | translate }}</p>
        <ul class="list-disc flex flex-col gap-1 m-0 pl-5 text-body-2 text-neutral-90">
          <li>{{ 'aiHub.preferences.consent.pointAccount' | translate }}</li>
          <li>{{ 'aiHub.preferences.consent.pointReadOnly' | translate }}</li>
          <li>{{ 'aiHub.preferences.consent.pointWithdraw' | translate }}</li>
        </ul>
        @if (store.automationsStatus() === 'ready') {
          <div class="flex flex-col gap-1 mt-2">
            <div class="flex items-start gap-2">
              <input
                type="checkbox"
                kendoCheckBox
                [id]="consentId"
                data-testid="exchange-consent-checkbox"
                [checked]="store.consentGiven()"
                [disabled]="store.consentBusy() || (!store.isAiEnabled() && !store.consentGiven())"
                (change)="onConsentChange($event)"
              />
              <kendo-label
                [for]="consentId"
                class="k-checkbox-label subtitle-2 text-neutral-90"
                [text]="'aiHub.preferences.consent.label' | translate"
              />
            </div>
            @if (!store.consentGiven() && (store.sessionsNotEnded() || store.turnOffFailed())) {
              <div data-testid="exchange-consent-error" class="flex items-center gap-3">
                <p class="text-body-2 text-neutral-90 m-0">
                  {{ (store.sessionsNotEnded() ? 'aiHub.preferences.consent.sessionsError' : 'aiHub.preferences.consent.turnOffError') | translate }}
                </p>
                <button data-testid="exchange-consent-retry" kendoButton type="button" [disabled]="store.consentBusy()" (click)="store.retryConsent()">
                  {{ 'aiHub.shell.retry' | translate }}
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @switch (store.automationsStatus()) {
    @case ('error') {
      <div class="flex flex-col items-start gap-3 py-6">
        <p class="text-body-2 text-neutral-90 m-0">{{ 'aiHub.preferences.loadError' | translate }}</p>
        <button data-testid="preferences-retry" kendoButton type="button" (click)="store.loadAutomations()">
          {{ 'aiHub.shell.retry' | translate }}
        </button>
      </div>
    }
    @case ('ready') {
      @for (preference of store.preferences(); track preference.id) {
        <ai-hub-preference-card
          [preference]="preference"
          [timeFormat]="store.timeFormat()"
          (orgChange)="store.setOrgPreference(preference.id, $event)"
          (mineChange)="store.setUserPreference(preference.id, $event)"
          (toggleSettings)="store.togglePreferenceSettings(preference.id)"
          (settingChange)="store.setPreferenceSetting(preference.id, $event)"
        />
      } @empty {
        <p class="text-body-2 text-neutral-60 m-0 py-6">{{ 'aiHub.preferences.empty' | translate }}</p>
      }
    }
    @default {
      <div data-testid="preferences-loading" class="flex justify-center py-12">
        <span class="k-icon k-font-icon k-i-loading" aria-hidden="true"></span>
      </div>
    }
  }
</div>
@if (consentPanelShown() && store.withdrawConfirmOpen()) {
  <kendo-dialog
    [title]="'aiHub.preferences.consent.dialogTitle' | translate"
    [width]="480"
    [maxWidth]="'90%'"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
    (close)="store.cancelWithdrawConsent()"
  >
    <div class="flex flex-col gap-2">
      <p class="text-body-2 text-neutral-90 m-0">{{ 'aiHub.preferences.consent.dialogBody' | translate }}</p>
      <p class="text-body-2 text-neutral-90 m-0">{{ 'aiHub.preferences.consent.dialogBodyRetick' | translate }}</p>
    </div>
    <kendo-dialog-actions layout="end">
      <button kendoButton type="button" fillMode="outline" data-testid="exchange-consent-cancel" (click)="store.cancelWithdrawConsent()">
        {{ 'aiHub.preferences.consent.cancel' | translate }}
      </button>
      <button
        kendoButton
        type="button"
        themeColor="error"
        data-testid="exchange-consent-turn-off"
        [disabled]="store.consentBusy()"
        (click)="store.confirmWithdrawConsent()"
      >
        {{ 'aiHub.preferences.consent.turnOff' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
